import { FinancialObligationOptions } from '@hb/domain/steps/financial-obligation';
import { OptionPipe } from '@hb/modules/financial-obligations/transformer/option/option-pipe';

import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentPipe } from '@ap/content';
import { ApNotificationComponent } from '@ap/notification';
import { ApCheckboxComponent } from '@ap/checkbox';

import { PreviousButtonComponent } from '../../global/button/previous-button/previous-button.component';
import { NextButtonComponent } from '../../global/button/next-button/next-button.component';
import { AbstractOption } from '../abstract-options.component';

@Component({
    selector: 'financial-obligations-options',
    imports: [
        ReactiveFormsModule,
        OptionPipe,
        ApContentPipe,
        ApNotificationComponent,
        NextButtonComponent,
        PreviousButtonComponent,
        ApCheckboxComponent
    ],
    templateUrl: './financial-obligations-options.component.html'
})
export class FinancialObligationsOptionsComponent extends AbstractOption {
    nextQuestion(): void {
        if (this.isInvalid()) {
            this.optionsForm.markAsTouched();
        } else {
            this.store.setFinancialObligationsOptions(this.optionsForm.value as FinancialObligationOptions);
            this.store.nextOption();
        }
    }

    previousQuestion(): void {
        this.store.backOption();
    }
}
